import type { Bbox } from "utils/math/bboxCenter";
import type { MarkerNote } from "components/SmartSurveyor/SmartSurveyorForRudolfFritz/utils/types";

export interface DetectedObject {
  id: string;
  rgb: [number, number, number];
  /** Bbox in scaled (display) coordinate space. */
  bbox: {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
  };
  status: string;
  // Only floor plan markers carry one; other overlays leave it out.
  note?: MarkerNote | null;
}

export const isDetectedObject = (object: {
  id: string;
}): object is DetectedObject => "bbox" in object;

export interface ZoomToElementsArgs {
  elements: {
    x: number;
    y: number;
  }[];
  padding?: number;
}

export type ZoomToElements = (args: ZoomToElementsArgs) => void;

export type ZoomToObject = (obj: { x: number; y: number }) => void;

export type ZoomToBbox = (bbox: Bbox) => void;

// Pick mode places something (crosshair) or only claims the clicks (grab)
export type PickZoneCursor = "crosshair" | "grab";

export interface DrawObjectsOnCanvasArgs {
  visible?: boolean;
  isFlashMode?: boolean;
  objects?: DetectedObject[];
}

export type DrawObjectsOnCanvas = (args: DrawObjectsOnCanvasArgs) => void;

export interface ZoomState {
  zoomLevel: number;
  panOffset: { x: number; y: number };
}

export interface FloorPlanPanelHandlers {
  zoomToFit: () => void;
  zoomToObject: ZoomToObject;
  zoomToBbox: ZoomToBbox;
  zoomToElements: ZoomToElements;
  flashCanvas: (duration?: number) => void;
  flashRipple: () => void;
  getZoomState: () => ZoomState;
  setZoomState: (state: ZoomState) => void;
}

export interface ActionButtonsProps {
  isDisabled: boolean;
  isMapClickModeEnabled: boolean;
  onToggle: () => void;
}
